import { render, staticRenderFns } from "./UserForgetPassword.vue?vue&type=template&id=89814b6a"
import script from "./UserForgetPassword.vue?vue&type=script&lang=js"
export * from "./UserForgetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports